<template>
	<section class="wrapper d-flex">
		<!-- <div class="logoWithBg"><img src="../../../static/prism/images/shoonya_whiteIn.svg" alt="#" class="logo_sec" /></div> -->
		<app-LeftNavigation
			v-if="get_user && get_user.client_code && parseInt(get_user.step) > 5 && (Object.keys(userAuthStateSave).length == 0 || (Object.keys(userAuthStateSave).length > 0 && userAuthStateSave.footer == 'y'))">
		</app-LeftNavigation>
		<div class="RightSideArea w-100" v-if="get_user && get_user.client_code">
			<div v-if="get_user && get_user.client_code && parseInt(get_user.step) > 5 && (Object.keys(userAuthStateSave).length == 0 || (Object.keys(userAuthStateSave).length > 0 && userAuthStateSave.footer == 'y'))" class="support_ticket">
				<a href="https://direct.lc.chat/13534029/3" target="_blank()">
					<!-- <img src="../../../../static/prism/images/chat.svg" alt="#" /> -->
					<img src="../../../static/prism/images/chat.svg" alt="#" />
				</a>
			</div>
			<app-login
				v-if="parseInt(get_user.step) > 5 && (Object.keys(userAuthStateSave).length == 0 || (Object.keys(userAuthStateSave).length > 0 && userAuthStateSave.header == 'y'))">
			</app-login>
			<app-registerheader
				v-if="parseInt(get_user.step) <= 5 && (Object.keys(userAuthStateSave).length == 0 || (Object.keys(userAuthStateSave).length > 0 && userAuthStateSave.header == 'y'))">
			</app-registerheader>
			<!-------------------loader---------------------------------------->
			<div class="loader-info" v-if="pageLoader && $route.path != '/Users/register/step6'">
				<loaderShoonya></loaderShoonya>
			</div>
			<!---------------------end of loader-------------------------------->
			<div class="addField-template" v-if="parseInt(get_user.step) <= 5">
				<vue-scroll>
					<div class="p-0 scrollAble">
						<div class="container-fluid">
							<div class="row justify-content-center">
								<div class="col-12">
									<router-view />
								</div>
							</div>
						</div>
					</div>
				</vue-scroll>
			</div>
			<router-view v-else />
		</div>
	</section>
</template>

<script>
import Loginheader from './shared/header'
import RegisterHeader from './shared/RegisterHeader'
import LeftNavigation from './shared/left_navigation'
import Footer from './shared/footer'
import { prismMixins } from '@/plugins/prism'
import * as types from '@/types'
import { mapActions } from 'vuex'
import '../../../static/prism/js/jquery-ui.js'
import loaderShoonya from './shared/loaderShoonya.vue';
export default {
	name: 'PrismApp',
	mixins: [prismMixins],
	data() {
		return {
			DEFAULT_SHOW_ENTERIES: "10",
			pageLoader: false,
			header_nav_show_panel: "",
			"pageLoader1": true,

			// pageLoader : false,
			userAuthStateSave: {}

		}
	},
	watch:{
		$route(val){
			if(!val.path.includes("register")){
				document.body.style.setProperty('background', '#F2F4FB')
			}
		}
	},
	methods: {
		...mapActions({
			_runStateLoad: types.RUN_STATE_LOAD,
		}),
		otherApiCall() {
			let input_json = {
				"rout": this.rout,
				"parameter": this,
				"mutation_variable": "SET_PROFILE_LIST"
			};
			this._runGetListingData(input_json)
			//this._runGetCouponList({  "parameter": this  })
			let input_json1 = {
				"client_code": this.$store.getters['GET_USER'].client_code,
				"client_id": this.$store.getters['GET_USER'].profile.pid,
				"request_type": 'myportfolio',
				"parameter": this,
			};
			this._runGetPortfolioList(input_json1)
		}
	},
	components: {
		appLogin: Loginheader,
		appRegisterheader: RegisterHeader,
		appLeftNavigation: LeftNavigation,
		appFooter: Footer,
		loaderShoonya
	},
	created() {

		if (localStorage.getItem('userAuthStateSave')) {
			this.userAuthStateSave = JSON.parse(localStorage.getItem('userAuthStateSave'))
		}

		var get_user_state = this.$store.getters['GET_USER'];
		const r = this.$router
		this._runStateLoad({ 'router': this.$router })
		this.otherApiCall()
	}
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/prism/index.vue